import "./Header.css";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCaretDown, faBars } from '@fortawesome/free-solid-svg-icons';
import LocalizationService from "../../application/services/LocalizationService";

const Header: React.FC = () => {
  const [languageDropdown, setLanguageDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const languageDropdownRef = useRef<HTMLDivElement>(null);

  const toggleLanguageDropdown = () => {
    setLanguageDropdown(!languageDropdown);
  };

  const handleLanguageChange = (lang: string) => {
    LocalizationService.changeLanguage(lang).then(() => {
      // Dil değişikliğinin tüm uygulamaya yansıması için sayfayı yenile
      window.location.reload();
    });
    setLanguageDropdown(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setLanguageDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target as Node)
      ) {
        setLanguageDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLanguage = LocalizationService.getCurrentLanguage();
  const isEnglish = currentLanguage === 'en';
  const languageText = isEnglish ? "English" : "Türkçe";

  return (
    <header className="main-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="header-logo">
            <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="" className="header-logo-icon" />
            GetSpeakHub
          </Link>
        </div>

        <div className="header-content">
          <div className="dropdown-container" ref={languageDropdownRef}>
            {languageDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-item" onClick={() => handleLanguageChange('en')}>
                  English
                </div>
                <div className="dropdown-item" onClick={() => handleLanguageChange('tr')}>
                  Türkçe
                </div>
              </div>
            )}
          </div>
        </div>

        <button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Menu"
        >
          <span className="menu-icon"><FontAwesomeIcon icon={faBars} /></span>
        </button>

        {mobileMenuOpen && (
          <div className="mobile-menu">
            <div className="mobile-menu-header">
              <Link to="/" className="header-logo" onClick={closeMobileMenu}>
                GetSpeakHub
              </Link>
              <button
                className="mobile-menu-close"
                onClick={closeMobileMenu}
                aria-label="Close menu"
              >
                <span className="close-icon"><FontAwesomeIcon icon={faTimes} /></span>
              </button>
            </div>

          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
